UC.views.AccountPasswordExpired = Backbone.View.extend({

  initialize: function() {
    this.passwordForm = new UC.components.PasswordForm({
      el: '#frmChangePassword'
    })
  }

});
